// @flow
import React, { useState, useEffect } from "react";
import { Button, Table, Input } from "reactstrap";
import { useCurrentRoute, useNavigation } from "react-navi";
import { useFormInput } from "../../../hooks/generalHooks";
import categoryService from "../../../services/api/categoryService";
import { toast } from "react-toastify";

export function Categories(props) {
  const newCategory = useFormInput("");
  const [categories, setCategories] = useState([]);
  const { data, onChange } = props;
  const route = useCurrentRoute();
  const navigation = useNavigation();

  useEffect(() => {
    setCategories(data);
  }, []);

  async function handleDelete(event) {
    event.persist();
    const confirm = window.confirm(
      "Are you sure you want to delete this category? DELETING A CATEGORY REMOVES ALL ITS ASSOCIATED TEMPLATES!"
    );
    if (!confirm) return;
    const result = await categoryService.deleteCategory(event.target.value);
    if (result) {
      if (
        route.data.config &&
        route.data.config.category === event.target.value
      ) {
        // if we're currently modifying a template and its category is the one that has just been deleted
        // then the template itself has been deleted, we must navigate back
        navigation.navigate("/templates");
      }
      // If the deletion is successful then we need to delete the category from our own state attribute
      const newCategories = categories.filter(
        category => category._id !== event.target.value
      );
      setCategories(newCategories);

      // Update the parent
      onChange(newCategories);
    }
  }
  async function handleAdd() {
    // if after removing spaces it's empty then don't send anything
    const trimmedCategoryName = newCategory.value.trim();
    if (!trimmedCategoryName) return;

    const data = new FormData();
    data.append("name", trimmedCategoryName);

    const result = await categoryService.createCategory(data);
    if (result) {
      const [res, err] = await categoryService.getCategories();
      if (err) {
        toast.error(`Error: ${err.message}`, {
          bodyClassName: "text-danger"
        });
      }
      setCategories(res.data);
      // Update the parent
      onChange(res.data);
    }
  }

  let rows;
  rows = categories.map((category, index) => (
    <tr>
      <th scope="row">{index + 1}</th>
      <td>{category.name}</td>
      <td>
        <Button
          className="btn-red"
          outline
          color="danger"
          value={category._id}
          onClick={handleDelete}
        >
          Delete
        </Button>
      </td>
    </tr>
  ));

  // Push the last row that has the input field for category creation
  rows.push(
    <tr>
      <td colSpan="2">
        <Input id="name" name="name" type="text" {...newCategory.formProps} />
      </td>
      <td>
        <Button
          outline
          color="dark"
          className="col-md-12 btn-black"
          onClick={handleAdd}
        >
          Create
        </Button>
      </td>
    </tr>
  );
  return (
    <Table>
      <thead>
        <tr>
          <th>#</th>
          <th>Category name</th>
          <th />
        </tr>
      </thead>
      <tbody>{rows}</tbody>
    </Table>
  );
}
export default Categories;



// WEBPACK FOOTER //
// ./src/views/template/template-form-sections/Categories.jsx